import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      let attempts = 0;
      let timeoutId: number | undefined;

      const tryScroll = () => {
        const el = document.querySelector(hash);

        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }

        if (attempts < 20) {
          attempts += 1;
          timeoutId = window.setTimeout(tryScroll, 100);
        }
      };

      tryScroll();

      return () => {
        if (timeoutId) {
          window.clearTimeout(timeoutId);
        }
      };
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
